var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"px-6 card-pad d-flex align-center",attrs:{"border":"left","colored-border":"","height":"75","color":"error"}},[_c('h4',[_c('strong',{staticStyle:{"color":"#ff5252"}},[_vm._v("Setor Desativado")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }